import styled, { css, DefaultTheme } from 'styled-components';
import useReadLocalStorage from '@/hooks/useReadLocalStorage';
import { ToolbarPositions } from '@/components/draggableToolbar/DraggableToolbar.types';

export default styled.a`
  ${({ theme }: { theme: DefaultTheme }) => {
    const pos = useReadLocalStorage(
      'contensis-blocks-preview-toolbar-position'
    );
    return css`
      position: relative;
      background: var(--primary-color);
      border-radius: 0.188em;
      width: 2.75em;
      height: 2.5em;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(180deg);
      @media ${theme.mq.min.tablet} {
        transform: rotate(0);
      }
      &:hover {
        background: var(--color-midnight);
        @media ${theme.mq.min.tablet} {
          .link__tooltip {
            display: block;
          }
        }
      }
      &:focus {
        outline: 0.125em solid transparent;
        box-shadow: inset 0 0 0 0.125em var(--a11y);
        @media ${theme.mq.min.tablet} {
          .link__tooltip {
            display: block;
          }
        }
      }
      .link__tooltip {
        position: absolute;
        right: 3.25em;
        top: 50%;
        transform: translateY(-50%);
        max-width: fit-content;
        white-space: nowrap;
        height: fit-content;
        display: none;
        ${(pos === ToolbarPositions.TopLeft ||
          pos === ToolbarPositions.CenterLeft ||
          pos === ToolbarPositions.BottomLeft) &&
        css`
          left: 3.25em;
        `}
      }
    `;
  }};
`;
